const responsiveStorageNameSpace = "ysys-web-";

export { responsiveStorageNameSpace };
